/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020-2021, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
*/

import { FeatureFlagRouter } from '../interfaces/feature-flag-router.interface';

/**
 * Angular AccountFeatureFlag model.
 */
export class AccountFeatureFlagRouter implements FeatureFlagRouter {
  /**
   * FeatureFlag enum.
   */
  static FeatureFlag = {
    CKE: 'cke',
  };

  private routedFeatureNames : Array< string > = [AccountFeatureFlagRouter.FeatureFlag.CKE];

  private currentUser : any;

  /**
   * Default Constructor.
   *
   * @param currentUser The user that is currently authenticated.
   */
  constructor(currentUser : any) {
    this.currentUser = currentUser;
  }

  /**
   * @inheritDoc
   */
  isFeatureFlagEnabled(featureName : string): boolean {
    if (!this.routedFeatureNames.includes(featureName)) {
      throw new Error(`Router was given unsupported feature name. Received : ${featureName} instead!`);
    }

    if (!this.currentUser.isAuthenticated()) {
      return false;
    }
    return (this.currentUser.enabledFeatureFlags)
      ? this.currentUser.enabledFeatureFlags.includes(featureName)
      : false;
  }

  /**
   * @inheritDoc
   */
  getRoutedFeatureNames(): Array< string > {
    return this.routedFeatureNames;
  }
}
